import DrawingBoard from "@/components/Exercises/DrawHappyPlace/DrawingBoard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/(content)/children/exercises/(shared)/happy-place/drawing-board"
)({
  component: RouteComponent,
    head: () => ({
    meta: [
      {
        title: "My Happy Place Drawings - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "happy-place.drawingBoard",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  return (
    <div className="max-w-xl mx-auto">
      <DrawingBoard />
     </div>
  );
}
